import React, { useState, useEffect } from 'react';
import styles from './Home.module.css';
import { useMediaQuery } from 'react-responsive';

export const Home: React.FC = () => {
    
    const isMobile = useMediaQuery({ maxWidth: 767 });
    
    const addTimestamp = (url: string) => {
        return `${url}?t=3`;
    };
    
    return (
        <div className={styles.container}>
            <div className={`${styles.heroSection} ${styles.fadeIn}`}>
            {isMobile ? (
                <h1 className={styles.pageTitle}>青少年的中英双语编程教育 <br /> 开拓孩子的国际化视野</h1>
            ) : (
                <h1 className={styles.pageTitle}>青少年的中英双语编程教育 - 开拓孩子的国际化视野</h1>
            )}
            <div className={styles.heroContentCentered}>
                <div className={styles.valueProposition}>
                    <p>中英双语教学，培养孩子的<span className={styles.emphasisText}>英语</span>、<span className={styles.emphasisText}>数学</span>和<span className={styles.emphasisText}>编程能力</span>和<span className={styles.emphasisText}>逻辑思维</span>能力，让孩子在激烈的竞争中脱颖而出</p>
                </div>
            </div>
                
            </div>
                
            <div className={styles.featuresSection}>
                <h2 className={styles.sectionTitle}>功能强大</h2>
                <div className={`${styles.featureRow} ${styles.slideInRight}`}>
                    {isMobile ? (
                        <>
                            <div className={styles.featureTextContainer}>
                                <h3 className={styles.featureTitle}>有声的中英双语课程</h3>
                                <p className={styles.featureText}>中英对照显示，英语、数学和编程同步学</p>
                                <p className={styles.featureText}>自然纯正的发音，提升英语听说读写能力</p>
                            </div>
                            <img src={addTimestamp("/image/home1.webp")} alt="AI翻译和语音朗读特性" className={styles.featureImage} />
                        </>
                    ) : (
                        <>
                            <div className={styles.featureTextContainer}>
                                <h3 className={styles.featureTitle}>有声的中英双语课程</h3>
                                <p className={styles.featureText}>中英对照显示，英语、数学和编程同步学</p>
                                <p className={styles.featureText}>自然纯正的发音，提升英语听说读写能力</p>    
                            </div>
                            <img src={addTimestamp("/image/home1.webp")} alt="AI翻译和语音朗读特性" className={styles.featureImage} />
                        </>
                    )}
                </div>
                <div className={`${styles.featureRow} ${styles.slideInRight}`}>
                {isMobile ? (
                    <>
                        <div className={styles.featureTextContainer}>
                            <h3 className={styles.featureTitle}>人工智能助教</h3>
                            <p className={styles.featureText}>人工智能助教24小时在线，随时答疑解惑</p>
                        </div>
                        <img src={addTimestamp("/image/ai.webp")} alt="AI助教特性" className={styles.featureImage} />
                    </>
                ) : (
                    <>
                        <img src={addTimestamp("/image/ai.webp")} alt="AI助教特性" className={styles.featureImage} />
                        <div className={styles.featureTextContainer}>
                            <h3 className={styles.featureTitle}>人工智能助教</h3>
                            <p className={styles.featureText}>人工智能助教24小时在线，随时答疑解惑</p>
                        </div>
                    </>
                )}
                </div>

                <div className={`${styles.featureRow} ${styles.slideInLeft}`}>
                    {isMobile ? (
                        <>
                            <div className={styles.featureTextContainer}>
                                <h3 className={styles.featureTitle}>多格式学习资源转换</h3>
                                <p className={styles.featureText}>上传文件生成双语对照翻译和音频</p>
                            </div>
                            <img src={addTimestamp("/image/home2.webp")} alt="资源上传特性" className={styles.featureImage} />
                        </>
                    ) : (
                        <>
                            <div className={styles.featureTextContainer}>
                                <h3 className={styles.featureTitle}>多格式学习资源转换</h3>
                                <p className={styles.featureText}>上传文件生成双语对照翻译和音频</p>
                            </div>
                            <img src={addTimestamp("/image/home2.webp")} alt="资源上传特性" className={styles.featureImage} />
                        </>
                    )}
                </div>
            </div>
            
            <div className={`${styles.testimonials} ${styles.fadeIn}`}>
                <h2 className={styles.sectionTitle}>学习者的成长故事</h2>
                <div className={styles.testimonialGrid}>
                    <div className={styles.testimonialCard}>
                        <div className={styles.quoteIcon}>"</div>
                        <p>自从学习了极客ABC的编程课程后，我不仅能开发手机应用，还能轻松的看懂学校的英语课本，不看字幕也能看懂大部分的英语视频！</p>
                        <div className={styles.testimonialProfile}>
                                <p className={styles.testimonialAuthor}>上海的学员，14岁</p>
                        </div>
                    </div>
                    <div className={styles.testimonialCard}>
                        <div className={styles.quoteIcon}>"</div>
                        <p>没想到我的孩子也可以享受到国际化的中英双语教育而且还是很实惠的价格，对于我这样的普通家庭是不敢想的，现在孩子的逻辑思维有了显著的提升，英语还拿到了年级第一的名次！</p>
                        <div className={styles.testimonialProfile}>
                                <p className={styles.testimonialAuthor}>14岁学员的家长</p>
                        </div>
                    </div>
                    <div className={styles.testimonialCard}>
                        <div className={styles.quoteIcon}>"</div>
                        <p>学英语最高效的方式是通过爱好来学习，编程正好是我的爱好之一，越学越有趣，现在我不仅学会了开发网站和使用各种AI工具，还学习了高中的一些数学知识，还能用英语和别人交流。</p>
                        <div className={styles.testimonialProfile}>
                                <p className={styles.testimonialAuthor}>杭州的学员，13岁</p>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className={`${styles.learningPathSection} ${styles.fadeIn}`}>
                <h2 className={styles.sectionTitle}>学习路线规划</h2>
                <div className={styles.timelineContainer}>
                    <div className={styles.timelinePhase}>
                        <div className={styles.timelineHeader}>
                            <div className={styles.timelineDot}></div>
                            {isMobile ? (
                                <h3 className={styles.phaseTitle}>第一阶段：编程基础</h3>
                            ) : (
                                <h3 className={styles.phaseTitle}>第一阶段：编程基础（6-8个月）</h3>
                            )}
                        </div>
                        <div className={styles.timelineContent}>
                            <div className={styles.timelineItem}>
                                <h4>Python入门（2-3个月）</h4>
                                {isMobile ? (
                                    <ul>
                                        <li>从"Python - 最简单的编程语言"课程开始</li>
                                        <li>学习Python基础语法和数据结构</li>
                                        <li>适合初学者的编程语言，易于上手</li>
                                    </ul>
                                ) : (
                                    <ul>
                                        <li>从"Python - 最简单的编程语言"课程开始</li>
                                        <li>学习内容：Python入门导引、使用Python解释器、Python非正式入门、流程控制进阶、数据结构等</li>
                                        <li>这是最适合初学者的编程语言，语法简单，容易上手</li>
                                    </ul>
                                )}
                            </div>
                            <div className={styles.timelineItem}>
                                <h4>网页开发基础（2个月）</h4>
                                {isMobile ? (
                                    <ul>
                                        <li>学习HTML、CSS和JavaScript基础</li>
                                        <li>制作简单网页项目，增加作品集</li>
                                    </ul>
                                ) : (
                                    <ul>
                                        <li>学习HTML网页结构</li>
                                        <li>学习CSS网页美化</li>
                                        <li>学习JavaScript网页交互基础</li>
                                        <li>这些技能可以帮助你制作简单的网页项目，增加作品集</li>
                                    </ul>
                                )}
                            </div>
                            <div className={styles.timelineItem}>
                                <h4>计算机数学基础（2-3个月）</h4>
                                {isMobile ? (
                                    <ul>
                                        <li>学习二进制和逻辑运算</li>
                                        <li>学习集合论入门</li>
                                        <li>为算法学习打下基础</li>
                                    </ul>
                                ) : (
                                    <ul>
                                        <li>学习二进制 - 计算机的数字世界</li>
                                        <li>学习逻辑运算 - 计算机的思维方式</li>
                                        <li>学习集合论入门 - 数据的分类与组织</li>
                                        <li>这些数学知识是编程的基础，也是算法学习的前提</li>
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    
                    <div className={styles.timelinePhase}>
                        <div className={styles.timelineHeader}>
                            <div className={styles.timelineDot}></div>
                            {isMobile ? (
                                <h3 className={styles.phaseTitle}>第二阶段：算法与数据结构</h3>
                            ) : (
                                <h3 className={styles.phaseTitle}>第二阶段：算法与数据结构（6-8个月）</h3>
                            )}
                        </div>
                        <div className={styles.timelineContent}>
                            <div className={styles.timelineItem}>
                                <h4>数据结构与算法基础（3-4个月）</h4>
                                {isMobile ? (
                                    <ul>
                                        <li>学习基本数据结构</li>
                                        <li>掌握基本排序和搜索算法</li>
                                    </ul>
                                ) : (
                                    <ul>
                                        <li>学习数据结构与算法基础课程</li>
                                        <li>重点掌握：数组、链表、栈、队列等基本数据结构</li>
                                        <li>学习基本排序算法和搜索算法</li>
                                    </ul>
                                )}
                            </div>
                            <div className={styles.timelineItem}>
                                <h4>进阶编程语言学习（3-4个月）</h4>
                                {isMobile ? (
                                    <ul>
                                        <li>学习C++基础</li>
                                        <li>掌握面向对象编程</li>
                                        <li>为信息学奥赛做准备</li>
                                    </ul>
                                ) : (
                                    <ul>
                                        <li>学习C++基础（科技特长生的编程语言）</li>
                                        <li>重点掌握：C++的基本语法、面向对象编程、内存管理等</li>
                                        <li>C++在信息学奥赛中广泛使用，对参加竞赛有帮助</li>
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    
                    <div className={styles.timelinePhase}>
                        <div className={styles.timelineHeader}>
                            <div className={styles.timelineDot}></div>
                            {isMobile ? (
                                <h3 className={styles.phaseTitle}>第三阶段：项目与竞赛</h3>
                            ) : (
                                <h3 className={styles.phaseTitle}>第三阶段：项目实践与竞赛准备（6-8个月）</h3>
                            )}
                        </div>
                        <div className={styles.timelineContent}>
                            <div className={styles.timelineItem}>
                                <h4>项目开发实践（3-4个月）</h4>
                                {isMobile ? (
                                    <ul>
                                        <li>开发小项目</li>
                                        <li>建立个人作品集</li>
                                    </ul>
                                ) : (
                                    <ul>
                                        <li>使用学到的Python或C++知识开发小项目</li>
                                        <li>可以尝试开发：简单的游戏、数据分析工具、网页应用等</li>
                                        <li>建立个人作品集，为特长生申请做准备</li>
                                    </ul>
                                )}
                            </div>
                            <div className={styles.timelineItem}>
                                <h4>竞赛准备（3-4个月）</h4>
                                {isMobile ? (
                                    <ul>
                                        <li>参加青少年编程竞赛</li>
                                        <li>刷题训练算法思维</li>
                                    </ul>
                                ) : (
                                    <ul>
                                        <li>参加青少年编程竞赛（如信息学奥赛初赛、蓝桥杯青少年组等）</li>
                                        <li>刷算法题训练算法思维和解题能力</li>
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    
                    <div className={styles.timelinePhase}>
                        <div className={styles.timelineHeader}>
                            <div className={styles.timelineDot}></div>
                            {isMobile ? (
                                <h3 className={styles.phaseTitle}>第四阶段：特长生冲刺</h3>
                            ) : (
                                <h3 className={styles.phaseTitle}>第四阶段：特长生冲刺（3-4个月）</h3>
                            )}
                        </div>
                        <div className={styles.timelineContent}>
                            <div className={styles.timelineItem}>
                                <h4>强化训练</h4>
                                {isMobile ? (
                                    <ul>
                                        <li>针对性训练薄弱环节</li>
                                        <li>完善作品集，准备面试</li>
                                    </ul>
                                ) : (
                                    <ul>
                                        <li>针对性训练薄弱环节</li>
                                        <li>完善作品集，准备技术面试</li>
                                    </ul>
                                )}
                            </div>
                            <div className={styles.timelineItem}>
                                <h4>拓展学习</h4>
                                {isMobile ? (
                                    <ul>
                                        <li>了解人工智能基础知识</li>
                                        <li>学习人工智能提示词编写</li>
                                    </ul>
                                ) : (
                                    <ul>
                                        <li>了解人工智能基础知识</li>
                                        <li>学习人工智能提示词编写技巧</li>
                                        <li>这些新兴技术知识可以在面试中展示你的学习能力和视野</li>
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.timelineNote}>
                    {isMobile ? (
                        <b>* 此学习路线规划适合想成为科技特长生的青少年，根据个人基础和学习进度可适当调整</b>
                    ) : (
                        <b>* 此学习路线规划适合想成为科技特长生的青少年，根据个人基础和学习进度可适当调整</b>
                    )}
                </div>
            </div>
            
            <div className={`${styles.finalCta} ${styles.bounceIn}`}>
                <h2>加入极客ABC，开启编程与英语的双重进阶之旅</h2>
                <div className={styles.ctaButtons}>
                    <p className={styles.ctaNote}>已有超过1000名青少年通过极客ABC提升逻辑思维、英语、数学和编程能力</p>
                </div>
            </div>
        </div>      
    );
};